import { api } from 'services';

export async function showUser(id: number | string) {
    const { data } = await api.get(`/users/${id}`)
    return data;
}
